import { render, staticRenderFns } from "./CarCategoriesList.vue?vue&type=template&id=c4c0ee88&"
import script from "./CarCategoriesList.vue?vue&type=script&lang=js&"
export * from "./CarCategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./CarCategoriesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports